var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carriers-view"},[_c('div',{staticClass:"carriers-view__sidebar"},[_c('Sidebar')],1),_c('div',{staticClass:"carriers-view__content"},[_c('h1',{staticClass:"carriers-view__content--tittle"},[_vm._v("Carriers")]),_c('hr',{staticClass:"carriers-view__content--separator"}),_c('CarriersTable',{staticClass:"mt-5"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }